import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase";
import { v4 as uuidv4 } from "uuid";
import "./admin.css";

interface Member {
  id: string;
  name: string;
  role: string;
  phone: string;
  email: string;
  image_url: string;
}

export const AdminConducerePage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [members, setMembers] = useState<Member[]>([]);
  const [newMember, setNewMember] = useState<Partial<Member>>({});
  const [newImage, setNewImage] = useState<File | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "leadership_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setTitle(data.title || "");
        setDescription(data.description || "");
        setMembers(data.members || []);
      }
    };
    fetchData();
  }, []);

  const uploadHeaderImage = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `leadership/banner_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);
    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const uploadMemberImage = async (file: File, slug: string): Promise<string> => {
    const refPath = `leadership/members/${slug}_${Date.now()}`;
    const storageRef = ref(storage, refPath);
    const uploadTask = uploadBytesResumable(storageRef, file);
    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        undefined,
        reject,
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        }
      );
    });
  };

  const addMember = async () => {
    const { name, role, email, phone } = newMember;
    if (!name || !role || !email || !phone || !newImage) {
      alert("Completează toate câmpurile și încarcă o poză.");
      return;
    }

    const slug = name.toLowerCase().replace(/\s+/g, "-");
    const image_url = await uploadMemberImage(newImage, slug);

    const newEntry: Member = {
      id: uuidv4(),
      name,
      role,
      email,
      phone,
      image_url,
    };

    setMembers((prev) => [...prev, newEntry]);
    setNewMember({});
    setNewImage(null);
  };

  const deleteMember = (id: string) => {
    const confirm = window.confirm("Ești sigur că vrei să ștergi acest membru?");
    if (!confirm) return;
    setMembers((prev) => prev.filter((m) => m.id !== id));
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "leadership_page"), {
      header_image: headerImage,
      title,
      description,
      members,
    });
    alert("Pagina Conducere a fost salvată!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Pagina Conducere</h1>

      <label>Imagine banner:</label>
      <input type="file" accept="image/*" onChange={(e) => setHeaderFile(e.target.files?.[0] || null)} />
      <button onClick={uploadHeaderImage}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <label>Titlu:</label>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Titlul paginii"
      />

      <label>Descriere:</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Descriere"
      />

      <hr />
      <h2>Membri existenți</h2>
      {members.map((m) => (
        <div key={m.id} className="member-item">
          <img src={m.image_url} alt={m.name} className="thumb" />
          <div>
            <strong>{m.name}</strong>
            <p>{m.role}</p>
            <p>{m.email}</p>
            <p>{m.phone}</p>
            <button onClick={() => deleteMember(m.id)}>Șterge</button>
          </div>
        </div>
      ))}

      <hr />
      <h2>Adaugă membru nou</h2>
      <input
        type="text"
        placeholder="Nume"
        value={newMember.name || ""}
        onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
      />
      <input
        type="text"
        placeholder="Funcție"
        value={newMember.role || ""}
        onChange={(e) => setNewMember({ ...newMember, role: e.target.value })}
      />
      <input
        type="email"
        placeholder="Email"
        value={newMember.email || ""}
        onChange={(e) => setNewMember({ ...newMember, email: e.target.value })}
      />
      <input
        type="text"
        placeholder="Telefon"
        value={newMember.phone || ""}
        onChange={(e) => setNewMember({ ...newMember, phone: e.target.value })}
      />
      <label>Poza:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setNewImage(e.target.files?.[0] || null)}
      />
      <button onClick={addMember}>Adaugă</button>

      <hr />
      <button className="save-btn" onClick={saveAll}>Salvează tot</button>
    </div>
  );
};
